<template>
    <div class="form-group">
        <label><span>*</span>{{title}}</label>
        <label class="btn btn-info">
            <input  style="display:none;" type="file" accept="image/*" ref="fileupload" @change="PreviewImage" >
            <i class="far fa-file-image"></i> 上傳圖片
        </label>
        <p>Width:<b>{{width}}</b>px Height:<b>{{height}}</b>px 格式限制 PNG、JPG   檔案大小上限3mb</p>
        <div class="col-3">
            <img class="card-img-top" :src="src" >
            <div class="form-group" v-if="!is_upload">
                <p>Progress: {{uploadValue.toFixed()+"%"}} 
                <progress id="progress" :value="uploadValue" max="100" style="width:100%"></progress>  </p>
            </div>
        </div>
    </div>
</template>

<script>
import {fb, db } from '../../firebase'
export default {
    name: 'UploadFile',
    props:{
        name: '',
        id:'',
        title:'',
        height:'',
        width:'',
        src:''
    },
    data () {
        return {
            is_upload:true,
            uploadValue:100,
            data:{
                src:'',
                height:'',
                width:'',
                pic_name:''
            }
        }
    },
    methods: {
        PreviewImage(event) {

            if ( ( event.target.files[0].size / 1024 / 1024 ) > 3) {
                alert("檔案大小上限3mb!");
                this.$refs.fileupload.value=null;
            } else if ( event.target.files[0].type.toLowerCase().indexOf("jpeg") > -1 || event.target.files[0].type.toLowerCase().indexOf("png") > -1 ){
        
                this.is_upload = false;
                this.uploadValue = 0;
                this.data.pic_name = event.target.files[0].name;
                this.data.src = URL.createObjectURL(event.target.files[0]);
        
                var tmp = {};
                tmp.imageData =  event.target.files[0];
                tmp.src = URL.createObjectURL(event.target.files[0]);
                tmp.name = encodeURIComponent(event.target.files[0].name).replace(/['()]/g, escape);
                var img = new Image();
                var vm = this;
                img.onload = function () {
                    URL.revokeObjectURL(tmp.src);
                    tmp.height = this.height;
                    tmp.width = this.width;
                };
                img.src = tmp.src;

                this.onUpload(tmp);
            } else {
                alert("僅限定副檔名為PNG、JPG圖");
                this.$refs.fileupload.value=null;
            }
        },
        onUpload(tmp){

            const storageRef= fb.storage().ref(this.name + '/' + this.id + '/'+tmp.name).put(tmp.imageData);

            storageRef.on('state_changed',
                snapshot=>{
                    this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
                }, 
                error => {
                    console.log(error.message)
                }, 
                () => {
                    this.uploadValue=100;
                    
                    storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                        this.data.src =url;
                        this.is_upload = true;
                        this.data.height = tmp.height;
                        this.data.width = tmp.width;

                        console.log('success')
                        console.log(this.data.src)
                        this.$emit('update', this.data); 
                    });
                    
                
                }
            );

        }
    }
}
</script>
<style scoped>
.btn{
  color:white;
}
label span, .remind{
  color:#BE0000
}
</style>




// WEBPACK FOOTER //
// src/components/shared/UploadFile.vue